module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity/fraternity-your-why-medium-e2674a369d9426198471284c16380afc.jpg";